import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { COUNTRY_CODES } from "../constants/countryCodes";

const toDigits = (text) => text.replace(/\D/g, "");

// Countries can share a dial code (e.g. +1, +44), so each code is listed once.
// Sorted by its numeric parts: +1, +1-242, ..., +7, +20, ...
const DIAL_CODE_OPTIONS = [...new Set(COUNTRY_CODES.map(({ value }) => value))]
  .sort((a, b) => {
    const [aCode, aArea = 0] = a.split("-").map(Number);
    const [bCode, bArea = 0] = b.split("-").map(Number);
    return aCode - bCode || aArea - bArea;
  })
  .map((value) => ({ value }));

// "+91", "91" and "9" all find +91, separators are ignored ("1268" finds +1-268)
const filterDialCodes = (options, { inputValue }) => {
  const search = toDigits(inputValue);
  return search
    ? options.filter(({ value }) => toDigits(value).startsWith(search))
    : options;
};

export const CountrySelect = ({
  name = "country_code",
  value,
  onChange,
  error,
  helperText,
  label = "Country code",
  required = false,
  disabled = false,
}) => {
  const selectedDialCode =
    DIAL_CODE_OPTIONS.find((option) => option.value === String(value)) ||
    null;

  return (
    <Autocomplete
      fullWidth
      options={DIAL_CODE_OPTIONS}
      value={selectedDialCode}
      autoHighlight
      disableClearable
      disabled={disabled}
      getOptionLabel={(option) => `+${option.value}`}
      isOptionEqualToValue={(option, optionValue) =>
        option.value === optionValue.value
      }
      filterOptions={filterDialCodes}
      onChange={(event, newValue) => onChange(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};
